import axios from "axios";
import CryptoJS from "crypto-js";

axios.interceptors.request.use(
    async config => {
        config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('apiToken');
        config.headers['Content-Type'] = 'application/json';
        config.headers['versioneapp'] = process.env.VUE_APP_VERSIONE;
        config.headers['x-access-token'] = sessionStorage.getItem('loginData');
        config.headers['struttura'] = '140000';
        // config.headers['clientip'] = this.ip;
        return config;
    },
    error => {
        Promise.reject(error)
    });

// axios.interceptors.response.use(async function (response) {
//     // console.log("No Errore", rand, request)
//     console.log("No errore")
//     return response;
// }, async function (error) {
//     // console.log("Dentro", rand, request)
//     console.log("Sì errore")
//     if (error.response.status === 401 && !error.config._retry) {
//         // console.log("Dentro if", rand, request)
//         error.config._retry = true;
//         let tokenApi = await getTokenApi();
//         if(tokenApi.status !== 200){
//             sessionStorage.clear()
//             await window.alert("Sessione scaduta, rieffettuare l'accesso")
//             window.location.reload();
//             return error
//         }
//         await sessionStorage.setItem('apiToken', tokenApi.data.data.access_token)
//         // console.log("Fine", rand, request)
//         console.log("configgggggggg", error.config)
//         return axios(error.config)
//         // response.
//         // return BaseService.perfom(request)
//     }
// });

export default class BaseService {
    static ip = ""
    static async perfom (request) {
        const config = {
            baseURL: process.env.VUE_APP_URL_BACKEND,
            url: request.url,
            method: request.method,
            headers: request.headers,
            data: request.body,
            params: request.params,
        };
        if(this.ip == ""){
            try{
                const response = await fetch('https://api.ipify.org?format=json');
                if (response.ok) {
                    const data = await response.json(); // Converte il corpo della risposta in JSON
                    this.ip = data.ip
                }
            } catch (e) {
                console.log("Ip non recuperabile")
            }
        }
        try {
            return await axios(config);
        } catch (error) {

            if (error.response.status === 401) {
                let tokenApi = await getTokenApi();
                if(tokenApi.status !== 200){
                    sessionStorage.clear()
                    await window.alert("Sessione scaduta, rieffettuare l'accesso")
                    window.location.reload();
                    return error
                }
                await sessionStorage.setItem('apiToken', tokenApi.data.data.access_token)
                return await BaseService.perfom(request)
            } else {
                console.log("Error", error)
                throw error
            }

        }
    }
}

async function getTokenApi() {
    return axios({
        baseURL: process.env.VUE_APP_URL_BACKEND,
        url: "/api/v2.0/appecupt/auth/token",
        method: "POST",
        headers: {
            "client_credentials": CryptoJS.AES.encrypt(process.env.VUE_APP_CLIENT_CREDENTIALS, process.env.VUE_APP_PASSPHRASE).toString(),
        }
    });
}
